/* eslint-disable eqeqeq */
import {
  REFRESH_DEVICES,
  REMOVE_DEVICE,
  SELECT_DEVICE,
  FOLLOW_DEVICE,
  UPDATE_DEVICES,
  SHOW_ROUTES_FILTER
} from '../constants';

const DEFAULT_STATE = {
  devices: {},
  device: null,
  follow: null,
  stop: 0,
  initFolSpeed: {},
  showRoutesFilter: null,
};

const DevicesReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case REFRESH_DEVICES:
      state.devices = {};
      payload.forEach((device) => (state.devices[device.id] = device));
      return {
        ...state,
      };
    case UPDATE_DEVICES:
      payload.forEach((device) => (state.devices[device.id] = device));
      return {
        ...state,
      };
    case SELECT_DEVICE:
      return {
        ...state,
        device: payload,
      };
    case FOLLOW_DEVICE:
      return {
        ...state,
        follow: payload,
      };
    case REMOVE_DEVICE:
      delete state.devices[payload];
      return {
        ...state,
      };
    case SHOW_ROUTES_FILTER:
      return {
        ...state,
        showRoutesFilter: payload
      };
    default:
      return state;
  }
};

export default DevicesReducer;
